import { destroyElement, toCSS } from 'belter'
import { EVENT } from 'zoid/dist/zoid.frameworks'

const CLASS = {
  VISIBLE: 'zoid-visible',
  INVISIBLE: 'zoid-invisible',
}

export default ({
  uid,
  frame,
  prerenderFrame,
  doc,
  props,
  event,
  dimensions,
}) => {
  const { width, height } = dimensions

  if (!frame || !prerenderFrame) {
    return
  }

  frame.setAttribute('allowfullscreen', '')

  const div = doc.createElement('div')
  div.setAttribute('id', uid)

  const style = doc.createElement('style')
  if (props.cspNonce) {
    style.setAttribute('nonce', props.cspNonce)
  }

  style.appendChild(
    doc.createTextNode(`
            #${uid} {
                position: relative;
                width: ${width};
                height: ${height};
            }

            #${uid} > iframe {
                position: absolute;
                width: 100%;
                height: 100%;
                top: 0;
                left: 0;
                transition: opacity .2s ease-in-out;
            }

            #${uid} > iframe.${CLASS.INVISIBLE} {
                opacity: 0;
            }

            #${uid} > iframe.${CLASS.VISIBLE} {
                opacity: 1;
        }
        `),
  )

  div.appendChild(frame)
  div.appendChild(prerenderFrame)
  div.appendChild(style)

  prerenderFrame.classList.add(CLASS.VISIBLE)
  frame.classList.add(CLASS.INVISIBLE)

  event.on(EVENT.RENDERED, () => {
    prerenderFrame.classList.remove(CLASS.VISIBLE)
    prerenderFrame.classList.add(CLASS.INVISIBLE)

    frame.classList.remove(CLASS.INVISIBLE)
    frame.classList.add(CLASS.VISIBLE)

    setTimeout(() => {
      destroyElement(prerenderFrame)
    }, 1)
  })

  event.on(EVENT.RESIZE, ({ width: newWidth, height: newHeight }) => {
    if (typeof newWidth === 'number') {
      div.style.width = toCSS(newWidth)
    }

    if (typeof newHeight === 'number') {
      div.style.height = toCSS(newHeight)
    }
  })

  return div
}
